module.exports = __webpack_public_path__ + "images/company-cover-placeholder.4b1dcfca.png";